





















import VueOptions from '@utils/VueOptions'

settings =
  name: 'AudienceListingPersona'

  vue:
    props: ['audienceListing', 'options']

    computed:
      campaignPersonaSegments: -> @options?.target?.audience?.persona_segments || []
      profile: -> @audienceListing.persona_profile || {}
      profileTableData: ->
        data = []
        for type, profile of @profile
          { score } = profile
          continue unless score
          relevance = '-'
          relevance = 'up' if score >= 100 and type in @campaignPersonaSegments
          relevance = 'down' if score < 100 and type in @campaignPersonaSegments
          data.push { type, score, relevance }
        data.sort @personaSegmentSorter
        data

    methods:
      personaSegmentSorter: (a, b) ->
        if a.type in @campaignPersonaSegments is b.type in @campaignPersonaSegments
          b.score - a.score
        else if a.type in @campaignPersonaSegments
          -1
        else
          1

export default VueOptions.vue settings
